/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        primaryTitleContainer: {
            paddingTop: theme.spacing(4),
        },
        primaryTitle: {
            ...theme.custom.appLandingPage.primaryTitleStyle
        },
        secondaryTitle: {
            ...theme.custom.appLandingPage.secondaryTitleStyle,
            marginBottom: theme.spacing(3.5)
        },
        imgContainer: {
            marginTop: theme.spacing(3),
        },
        image: {
            '@media (max-width: 1280px)': {
                width: "100%",
                height: "100%"
            }
        },
        createBtn: {
            marginLeft: theme.spacing(0),
            marginBottom: theme.spacing(1.5)
        }
    })
);
